module.exports = __webpack_public_path__ + "img/40m3.c1ca9b8b.jpg";